export type ApprovalStage =
  | "engagement"
  | "product"
  | "provision"
  | "localRisk"
  | "globalRisk"
  | "extension";

export type ApprovalStatus = "approved" | "rejected" | "pending";

export interface ResolvedApprovalStatus {
  label: string;
  status: ApprovalStatus;
}

const stageLabels: Record<ApprovalStage, string> = {
  engagement: "Engagement",
  product: "Product",
  provision: "Provision",
  localRisk: "Local risk",
  globalRisk: "Global risk",
  extension: "Extension",
};

const autoProvisionedStages: ApprovalStage[] = [
  "engagement",
  "provision",
  "extension",
];

const rejectionRoleLabels: Record<string, string> = {
  sku_deploymentapprover: "provisioning approver",
  order_engagementpartner: "engagement approver",
  sku_globalriskmgr: "global risk approver",
  sku_localriskmgr: "local risk approver",
  sku_productapprover: "product approver",
  engagement_delegate: "engagement approver",
};

export const getApprovalStageLabel = (stage: ApprovalStage) =>
  stageLabels[stage];

export const getRejectionRoleLabel = (
  roleCd: string | null | undefined,
) => rejectionRoleLabels[roleCd as string];

export const resolveApprovalStatus = (
  rawStatus: string | null | undefined,
  stage: ApprovalStage,
  isAutoProvisioned = false,
): ResolvedApprovalStatus => {
  const isAutoApproved =
    isAutoProvisioned && autoProvisionedStages.includes(stage);
  let status: ApprovalStatus = "pending";

  if (isAutoApproved || rawStatus === "1") {
    status = "approved";
  } else if (rawStatus === "0") {
    status = "rejected";
  }

  if (stage === "extension") {
    return { status, label: "Engagement extension" };
  }

  return { status, label: getApprovalStageLabel(stage) };
};
